<script>
  let { value = $bindable(""), options = [], name, disabled = false } = $props()
  let index = $state(options.findIndex(opt => opt.value === value) || 0)
  let container = $state(null)

  function handleKeydown(e) {
    if (disabled) return
    if (["ArrowUp", "ArrowLeft"].includes(e.key)) {
      e.preventDefault()
      index = Math.max(0, index - 1)
      value = options[index].value
    } else if (["ArrowDown", "ArrowRight"].includes(e.key)) {
      e.preventDefault()
      index = Math.min(options.length - 1, index + 1)
      value = options[index].value
    }
  }
</script>

<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
<div bind:this={container} class="boolean-container" class:disabled tabindex="0" role="radiogroup"
  onkeydown={handleKeydown}
  onpointerdown={() => container?.focus()}>
  {#each options as option (option.value)}
    <label class="boolean-segment mb-0!" class:selected={option.value === value}>
      <input type="radio" {name} value={option.value} bind:group={value} disabled={disabled} />
      {option.label}
    </label>
  {/each}
</div>

<style>
  .disabled {
    opacity: 0.8;
    pointer-events: none;
  }

  .boolean-container:focus-visible {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
  }
</style>